export enum EDeployStatus {
  upload_changes = 'upload_changes',
  create_changes = 'create_changes',
  open = 'open',
  scheduled = 'scheduled',
  ready_to_deploy = 'ready_to_deploy',
  in_progress = 'in_progress',
  deployed = 'deployed',
  failed = 'failed',
}
